import "react-datepicker/dist/react-datepicker.css";
import NavBar from "../../Navbar/NavBar";
import Header from "../../Common/Header";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
import { getAPI, postAPI } from "../../utils/api";
import { IFan } from "../../utils/interface";
import { MediaBaseUrl } from "../../utils/BaseUrl";
import Spinner from "../../Common/Spinner";
import moment from "moment";

const Fans = () => {

	const [ loader, setLoader ] = useState<boolean>(false)
	const [ fans, setFans ] = useState<IFan[]>()
	const [isdisabled, setIsdisabled ] = useState(false)
	
	const getData = async () => {
		getAPI("/admin/getAllUsers?userType=fan").then(res => {
			if(res?.data?.status){
				setFans(res?.data?.data)
				toast.success(res?.data?.message,{autoClose: 2000})
			} else {
				toast.error(res?.data?.message,{autoClose: 2000})
			}
			setLoader(false)
		})
	}
	useEffect(() => {
		setLoader(true)
		getData()
	}, [])


	const handleSuspend = (userId: string, status: boolean) => {
		setIsdisabled(true)
	
			postAPI("/admin/user/suspend", {userId, status}).then((res) => {
				if (res?.data?.status) {
				  toast.success(res?.data?.message, { autoClose: 2000 });
				  getData();
				} else {
				  toast.error(res?.data?.message, { autoClose: 2000 });
				}
			})
		}

	return (<div>
		<NavBar />
		<div className="main-content">
			<Header text={"Fans Details"} />
			<div className="container-fluid pb-5">
				{/* Fans Detail */}
				<div className="border border-dark rounded border-top-0"  style={{ overflow: "auto" }}>
					<table className="rounded table mb-0">
						<thead>
							<tr >
								<th className="bg-dark text-white">#</th>
								<th className="bg-dark text-white min-w-190">Full Name</th>
								<th className="bg-dark text-white">Email</th>
								<th className="bg-dark text-white">D.O.B.</th>
								<th className="bg-dark text-white">Zip Code</th>
								<th className="bg-dark text-white"></th>
								<th className="bg-dark text-white"></th>
							</tr>
						</thead>
						<tbody>
							{    
								loader
								?
								<Spinner />
								: 
								(
									fans?.length
									?
									fans.map((fan: IFan, index:number) => {
										return <tr key={index}>
											<td className="border-bottom">{index+1}</td>
											<td className="border-bottom">
											<span className="user_profile border_rounded">
												<img src={fan.profilePic ? MediaBaseUrl+fan.profilePic : MediaBaseUrl+"/assets/images/follow/user.png"} alt={fan.firstName+" "+fan.lastName} className="user_profile mx-1 img-fluid border-rounded rounded-circle" />
											</span>
												{(fan.firstName?fan.firstName:"") + " " + (fan.lastName?fan.lastName:"")}
											</td>
											<td className="border-bottom">{fan.email?fan.email:"-"}</td>
											<td className="border-bottom">{fan.dateOfBirth ? moment(fan.dateOfBirth).format('MM/DD/YYYY') : "-"}</td>
											<td className="border-bottom">{fan.zipCode ? fan.zipCode : "-"}</td>
											<td className="border-bottom">
												{
													fan?.isActive
													?
													<span className="badge badge-success cursorPointer">Active</span>
													:
													<span className="badge badge-secondary cursorPointer">Suspended</span>
									            }
											</td>
											<td>
												<div className="dropdown">
													<a href="#/" className="dropdown-ellipses dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                                                    <i className="fe fe-more-vertical" style={{ color: "#12263F" }} />
                                                    </a>
                                                    <div className="dropdown-menu dropdown-menu-right">
														<button onClick={() => handleSuspend(fan.uid, true)} className="dropdown-item" disabled={fan.isActive ? true : false}> Active </button>
														<button onClick={() => handleSuspend(fan.uid, false)} className="dropdown-item" disabled={fan.isActive ? false : true}> Suspend </button>
                                                    </div>
                         
                                                </div>
											</td>

										</tr>
									})
									:
									<tr className="">No Data Found</tr>
								)
							}
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<ToastContainer />
	</div>
)}

export default Fans;
